module.exports = __webpack_public_path__ + "img/pwd_error.fa47b276.svg";